import { z } from "zod";

export const getAttendancesQuerySchema = z.object({
	pageSize: z.coerce.number().int().min(1).max(5000).default(50),
	offset: z.coerce.number().int().min(0).default(0),
	startDate: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
	endDate: z
		.string()
		.regex(/^\d{4}-\d{2}-\d{2}$/)
		.optional(),
});

export type GetAttendancesQuerySchema = z.infer<typeof getAttendancesQuerySchema>;
